
export const StateOptions = [
    { value: "1", label: "Andhra Pradesh" },
    { value: "2", label: "Arunachal Pradesh" },
    { value: "3", label: "Assam" },
    { value: "4", label: "Bihar" },
    { value: "5", label: "Chhattisgarh" },
    { value: "6", label: "Goa" },
    { value: "7", label: "Gujarat" },
    { value: "8", label: "Haryana" },
    { value: "9", label: "Himachal Pradesh" },
    { value: "10", label: "Jharkhand" },
    { value: "11", label: "Karnataka" },
    { value: "12", label: "Kerala" },
    { value: "13", label: "Madhya Pradesh" },
    { value: "14", label: "Maharashtra" },
    { value: "15", label: "Manipur" },
    { value: "16", label: "Meghalaya" },
    { value: "17", label: "Mizoram" },
    { value: "18", label: "Nagaland" },
    { value: "19", label: "Odisha" },
    { value: "20", label: "Punjab" },
    { value: "21", label: "Rajasthan" },
    { value: "22", label: "Sikkim" },
    { value: "23", label: "Tamil Nadu" },
    { value: "24", label: "Telangana" },
    { value: "25", label: "Tripura" },
    { value: "26", label: "Uttar Pradesh" },
    { value: "27", label: "Uttarakhand" },
    { value: "28", label: "West Bengal" },
  ];

export const handleApiError = (
  error,
  setStatusValue,
  setErrorPopupMessage,
  setErrorPopup,
  setButtonText
) => {
  const statusCode = error?.response?.data?.statusCode;
  const errorMessage = error?.response?.data?.message;

  setStatusValue(statusCode);

  if (statusCode === 400) {
    setErrorPopupMessage(errorMessage);
    setErrorPopup(true);
    setButtonText("Try Again");
  } else if (statusCode === 401 || statusCode === 403) {
    setErrorPopupMessage(errorMessage);
    setErrorPopup(true);
    setButtonText("Login");
  } else {
    setErrorPopupMessage("Something went wrong...");
    setErrorPopup(true);
    setButtonText("Try Again");
  }
};
